import React from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, FileText, Wallet as WalletIcon, Receipt, Scale, Settings as SettingsIcon, Users as UsersIcon, FileSpreadsheet, Gift, Trophy } from "lucide-react";
import { useNotifications } from "@/context/NotificationsContext";

const NavItem = ({ to, icon: Icon, label, testid, badge }) => (
  <NavLink
    to={to}
    end
    className={({ isActive }) =>
      `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
        isActive ? "bg-accent text-accent-foreground" : "text-muted-foreground hover:text-foreground hover:bg-secondary"
      }`
    }
    data-testid={testid}
  >
    <Icon className="w-4 h-4" />
    <span className="flex-1">{label}</span>
    {badge > 0 && (
      <span className="min-w-[18px] h-[18px] px-1 rounded-full bg-primary text-primary-foreground text-[10px] font-bold grid place-items-center" data-testid={`${testid}-badge`}>
        {badge > 9 ? "9+" : badge}
      </span>
    )}
  </NavLink>
);

const SideNav = ({ role }) => {
  const { unreadByCategory } = useNotifications();
  return (
  <nav className="flex flex-col gap-1 p-3">
    <div className="px-3 py-2 text-xs uppercase tracking-[0.2em] text-muted-foreground font-semibold">Workspace</div>
    <NavItem to="/dashboard" icon={LayoutDashboard} label="Dashboard" testid="nav-dashboard" />
    <NavItem to="/contracts" icon={FileText} label="Contracts" testid="nav-contracts" badge={unreadByCategory.contracts} />
    <NavItem to="/invoices" icon={FileSpreadsheet} label="Invoices" testid="nav-invoices" badge={unreadByCategory.invoices} />
    <NavItem to="/wallet" icon={WalletIcon} label="Earnings" testid="nav-wallet" />
    <NavItem to="/transactions" icon={Receipt} label="Transactions" testid="nav-transactions" badge={unreadByCategory.transactions} />
    <NavItem to="/disputes" icon={Scale} label="Disputes" testid="nav-disputes" badge={unreadByCategory.disputes} />
    <NavItem to="/rewards" icon={Gift} label="Rewards" testid="nav-rewards" />
    <NavItem to="/leaderboard" icon={Trophy} label="Leaderboard" testid="nav-leaderboard" />
    {role === "admin" && (
      <>
        <div className="px-3 pt-6 pb-2 text-xs uppercase tracking-[0.2em] text-muted-foreground font-semibold">Admin</div>
        <NavItem to="/admin/users" icon={UsersIcon} label="Users" testid="nav-admin-users" />
        <NavItem to="/admin/contracts" icon={FileText} label="All Contracts" testid="nav-admin-contracts" />
        <NavItem to="/admin/disputes" icon={Scale} label="Disputes" testid="nav-admin-disputes" />
      </>
    )}
    <NavItem to="/settings" icon={SettingsIcon} label="Settings" testid="nav-settings" />
  </nav>
  );
};

export default SideNav;
